import { useMutation } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import type { CopilotRequest, TranslateRequest } from "@/api/types";
import { useFlashToast } from "@/components/FlashToast/FlashToast";
import { isAbortError } from "@/helpers/isAbortError";
import { useTranslation } from "@/translations";

const useGetCopilotResponse = () => {
  const api = useApi();
  const { t } = useTranslation();
  const showFlashToast = useFlashToast();

  return useMutation({
    mutationFn: ({
      templateId,
      toneOfVoice,
      userInput,
      copilotOptions = [],
      signal,
    }: CopilotRequest & { signal?: AbortSignal }) =>
      api.postCopilotStreamV1(
        { userInput, templateId, toneOfVoice, copilotOptions },
        {
          format: undefined,
          signal,
        },
      ),
    onError: (error) => {
      if (!isAbortError(error)) {
        showFlashToast({ variant: "alert", message: t("page.message-feed.optimize.copilot-error") });
      }
    },
  });
};

const useTranslate = () => {
  const api = useApi();

  return useMutation({
    mutationFn: (payload: TranslateRequest) => api.postTranslationsTranslateV1(payload).then((x) => x.data),
  });
};

export const generalMutations = {
  useGetCopilotResponse,
  useTranslate,
};
